module.exports = __webpack_public_path__ + "071c96a0e6065060d9eb3b85810cd016.png";